class DictionaryDefinition {
  public definition: string;
  public ipa: string;
  public synonyms: string[];
  public antonyms: string[];
  public translation?: string;
  public audio_url?: string;

  constructor(
    definition: string,
    ipa: string,
    synonyms: string[],
    antonyms: string[],
    translation?: string,
    audio_url?: string,
  ) {
    this.definition = definition;
    this.ipa = ipa;
    this.synonyms = synonyms;
    this.antonyms = antonyms;
    this.translation = translation;
    this.audio_url = audio_url;
  }

  public static fromServerDefinition(serverDefinition: Record<string, any>) {
    return new DictionaryDefinition(
      serverDefinition['definition'],
      serverDefinition['ip'],
      serverDefinition['synonyms'],
      serverDefinition['antonyms'],
      serverDefinition['translation'],
      serverDefinition['audio_url'],
    );
  }
}

export default DictionaryDefinition;
